import { ToolConfig, ToolKind } from 'shared/interfaces/tools/Tool';

// Conditional type to extract the specific tool config type from the ToolConfig union
type ExtractToolConfig<T extends ToolKind> = Extract<ToolConfig, { kind: T }>;

// Generic function to get a tool configuration by its kind from a tool configs array
export function getToolConfig<T extends ToolKind>(
  toolConfigs: ToolConfig[],
  toolKind: T
): ExtractToolConfig<T> | undefined {
  return toolConfigs.find((config) => config.kind === toolKind) as ExtractToolConfig<T> | undefined;
}
